import React from 'react';
import styled, { keyframes } from 'styled-components';
import CumaModal from './v2/modal/CumaModal';

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(350deg);
    }
`;

const Spinner = styled.div`
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left: 4px solid #3498db;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: ${rotate} 1s linear infinite;

    background: #fff;
`;

function LoadingSpinner() {
    return (
        <CumaModal>
            <Spinner />
        </CumaModal>
    );
}

export default LoadingSpinner;
